import {Component, OnInit} from '@angular/core';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';
import * as L from 'leaflet';
import {Icon, latLng, Map, marker, tileLayer} from 'leaflet';
import {MapService} from '../../../app/shared/map.service';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-gelios-map-point-field',
    templateUrl: './gelios-map-point-field.component.html',
})
export class GeliosMapPointFieldComponent extends GeliosFieldBaseComponent implements OnInit {
    map: Map;

    leafletBaseLayers = {
        osm: tileLayer(environment.mapTileBaseUrl + '{z}/{x}/{y}.png', {minZoom: 4, maxZoom: 18, attribution: 'OSM'})
    };

    leafletOptions = {
        layers: [this.leafletBaseLayers.osm],
        zoomControl: true,
        attributionControl: false
    };

    private center: L.LatLng  = latLng(53.9, 27.55);
    private zoom = 12;
    public height = 500;
    private icon: Icon;

    leafletZoomOptions = {
        animate: true
    };

    constructor(
        protected translate: TranslateService,
        public mapService: MapService
    ) {
        super(translate);
    }

    ngOnInit() {
        super.ngOnInit();
        this.initMapConfig();
    }

    onMapReady(lmap: L.Map) {
      this.map = lmap;
      this.map.fitBounds(this.mapService.getInitialGeoBounds());
      this.mapService.enableDraw.next(true);
      this.mapService.mapReady.next(this.map);
      this.putLayer();
      this.map.setView(this.center, this.zoom);
      setTimeout(
          () => {
              this.map.invalidateSize();
          },
          300
      );
    }

    initMapConfig() {
      const mapConfig = this.model.fields[this.fieldName].mapPointConfig;
      if (mapConfig && mapConfig.height) {
        this.height = mapConfig.height;
      }
      if (mapConfig && mapConfig.center) {
        this.center = mapConfig.center;
      }
      if (mapConfig && mapConfig.zoom) {
        this.zoom = mapConfig.zoom;
      }
      if (mapConfig && mapConfig.icon) {
        this.icon = mapConfig.icon;
      }
    }

    putLayer() {
      const geo = this.formGroup.get(this.fieldName).value;
      if (geo === '' || geo === null || geo === undefined) {
        const layer = marker(
          this.center,
          {
            draggable: true,
            icon: this.icon ? this.icon : this.mapService.simpleIcon
          }
        );
        layer.addEventListener('dragend', (event) => {
          this.formGroup.get(this.fieldName).setValue(
            event.target.toGeoJSON().geometry.coordinates
          );
        });
        this.formGroup.get(this.fieldName).setValue(
          layer.toGeoJSON().geometry.coordinates
        );
        this.map.addLayer(layer);
      } else {
        const point = latLng(geo[1], geo[0]);
        const layer = marker(point, {
          draggable: true, icon: this.icon ? this.icon : this.mapService.simpleIcon
        });
        layer.addEventListener('dragend', (event) => {
          this.formGroup.get(this.fieldName).setValue(
            event.target.toGeoJSON().geometry.coordinates
          );
        });
        this.map.addLayer(layer);
        this.center = point;
      }
    }
}
